import ProductCard from '../components/ProductCard';
import UserSegmentation from '../components/UserSegmentation';
import Text from '../components/Text';
import LayoutRenderer from '../components/Layout/LayoutRenderer';
import Video from '../components/Video';
import ImageBanner from '../components/Image';
import Carousel from '../components/ContentCarousel';
import Position from '../components/Position';
import BrandSlider from '../components/BrandSlider';
import Button from '../components/Button';
import InlineLink from '../components/InlineLink';
import TextStyle from '../components/TextStyle';
import Shortcuts from '../components/Shortcuts';
import ArticleCard from '../components/ArticleCard';
import { withErrorBoundary } from 'react-error-boundary';
import ProductRecommendation from '../components/ProductRecommendation';
import CustomScriptBlock from '../components/CustomScriptBlock';

function ComponentRenderer(data) {
    try {
        switch (data?.sys?.contentType?.sys?.id) {
            case 'layout':
                return <LayoutRenderer {...data} />;
            case 'text':
                return <Text {...data} />;
            case 'position':
                return <Position {...data} />;
            case 'imageBanner':
                return <ImageBanner {...data} />;
            case 'userSegmentation':
                return <UserSegmentation {...data} />;
            case 'productCard':
                return <ProductCard {...data} />;
            case 'video':
                return <Video {...data} />;
            case 'carousel':
                return <Carousel {...data} />;
            case 'brandSlider':
                return <BrandSlider {...data} />;
            case 'textStyle':
                return <TextStyle {...data} />;
            case 'button':
                return <Button {...data} />;
            case 'inlineLink':
                return <InlineLink {...data} />;
            case 'shortcuts':
                return <Shortcuts {...data} />;
            case 'productRecommendation':
                return <ProductRecommendation {...data} />;
            case 'articleCard':
                return <ArticleCard {...data} />;
            case 'customScriptBlock':
                return <CustomScriptBlock {...data} />;
            default:
                throw new Error(`"${data?.sys?.contentType?.sys?.id}" is not recognized`);
        }
    } catch (e) {
        console.error(e);
        return null;
    }
}

export default withErrorBoundary(ComponentRenderer, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
